var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog', {
    attrs: {
      "width": "960",
      "scrollable": "",
      "fullscreen": _vm.$vuetify.breakpoint.mobile
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var attrs = _ref.attrs,
            on = _ref.on;
        return [_vm._t("activator", null, null, {
          attrs: attrs,
          on: on
        })];
      }
    }], null, true),
    model: {
      value: _vm.shows,
      callback: function callback($$v) {
        _vm.shows = $$v;
      },
      expression: "shows"
    }
  }, [_c('v-card', {
    staticClass: "d-flex flex-column",
    attrs: {
      "light": "",
      "tile": _vm.$vuetify.breakpoint.mobile
    }
  }, [_c('v-card-title', [_vm._v(" 상품권 "), _c('span', {
    staticClass: "ml-2 body-2 grey--text"
  }, [_vm._v(_vm._s(_vm.order.orderNo || "-") + " · " + _vm._s(_vm.pins.length) + "장 · 충전완료 " + _vm._s(_vm.gainedCount) + " / 미충전 " + _vm._s(_vm.pins.length - _vm.gainedCount))]), _c('v-spacer'), _c('v-btn', {
    staticClass: "mr-4",
    attrs: {
      "small": "",
      "color": "primary",
      "disabled": !_vm.pins.length
    },
    on: {
      "click": _vm.copy
    }
  }, [_vm._v(" " + _vm._s(_vm.copied ? "복사됨" : "PIN 전체 복사") + " ")]), _c('v-icon', {
    on: {
      "click": function click($event) {
        _vm.shows = false;
      }
    }
  }, [_vm._v("mdi-close")])], 1), _c('v-divider'), _c('v-card-text', {
    staticClass: "pt-4",
    staticStyle: {
      "flex": "1 1 auto",
      "min-height": "0",
      "overflow-y": "auto"
    }
  }, [_c('nshop-order-view-pins', _vm._b({
    attrs: {
      "label": false,
      "max-height": "calc(90vh - 120px)"
    }
  }, 'nshop-order-view-pins', {
    order: _vm.order
  }, false))], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }